import { ILeadRepository, LeadListResult } from '../../ports/ILeadRepository';

export class ListLeadsUseCase {
  constructor(private leadRepository: ILeadRepository) {}

  async execute(params?: { page?: number; perPage?: number }): Promise<LeadListResult> {
    return this.leadRepository.list(params);
  }
}